import FetchPostDataWithAuthNEW from "../services/FetchPostDataWithAuthNEW";

export default async function FechPostEditClient(club, body) {

  var url = "/reservation/edit_client/" + club;

  var data = await FetchPostDataWithAuthNEW(url, body)

  return data;
}
